// 判断是否为对象
export function isObject(val) {
  return val !== null && typeof val === 'object';
}

// 判断是否为数组
export function isArray(val) {
  return Array.isArray(val);
}

// 判断是否为空
export const isAnyBlank = (...args) => {
  const None = [undefined, null, 'undefined', '', 'null', ' '];
  for (const i of args) {
    if (None.includes(i)) {
      return true;
    }
  }
  return false;
};

// 判断该数组或对象是否为空
export function isEmpty(val) {
  if (isArray(val)) {
    return val.length === 0;
  }
  if (isObject(val)) {
    return JSON.stringify(val) === '{}';
  }
  return isAnyBlank(val);
}
